import React from 'react';

import { Badge } from './badge';
import { ITag } from '../models/tag';

interface IProps {
	tags: ITag;
}

export default function Tags({ tags }: IProps) {
	return (
		<p className="mt-8 text-lg font-bold">
			Tags:
			{tags.edges.map((tag, index) => (
				<Badge key={index} className="ml-4">
					{tag.node.name}
				</Badge>
			))}
		</p>
	);
}
